// TODO - Update types
export const isDayInCurrentMonth = (dayToCompare, daysInMonth) => {
    return daysInMonth.find((day) => dayToCompare.utc().isSame(day.customerDate, "month")) !== undefined;
};
// TODO - Update types
export const findSkipDay = (dayToCompare, daysInMonth) => {
    return daysInMonth.find((skipDay) => dayToCompare.utc().isSame(skipDay.customerDate, "day") && skipDay.skip);
};
// TODO - Update types
export const shouldDisableDate = (date, allSkipDays) => {
    let isEligibleSkipDay = allSkipDays.find((skipDay) => date.isSame(skipDay.customerDate, "day"));
    if (!isEligibleSkipDay) {
        return true;
    }
};
/**
 * ACCOUNT > SKIP DAY PAGE > Day Click Handler
 * @param handleOpenWarningModal
 * @param handleUpdateSkipDay
 * @param isDisableDay
 * @param isSkipDay
 * @param setDayToSkip
 * @param targetDay
 * @returns
 */
export const dayChangeHandler = (handleOpenWarningModal, handleUpdateSkipDay, isDisableDay, isSkipDay, setDayToSkip, targetDay) => () => {
    var _a, _b;
    if (!isDayInCurrentMonth || isDisableDay) {
        return console.debug("No action.");
    }
    // MUI's PickersDay button retains focus after click, keeping hover/focus styling visible
    // until the user clicks elsewhere. Blur immediately so the day shows its updated state cleanly.
    (_b = (_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.blur) === null || _b === void 0 ? void 0 : _b.call(_a);
    if (isSkipDay && handleUpdateSkipDay) {
        console.debug("Skip day action.");
        return handleUpdateSkipDay(isSkipDay.customerDate, false);
    }
    if (targetDay && !targetDay.hasMealsAssigned && handleUpdateSkipDay) {
        console.debug("No assigned meals action.");
        return handleUpdateSkipDay(targetDay.customerDate, true);
    }
    if (targetDay && !!targetDay.hasMealsAssigned && setDayToSkip && handleOpenWarningModal) {
        console.debug("Assigned meals action.");
        setDayToSkip(targetDay && targetDay.customerDate);
        return handleOpenWarningModal();
    }
    else {
        return console.debug("No action.");
    }
};
